<ion-menu (ionWillOpen)="ionMenuWillOpen()" side="end" contentId="main-content" type="overlay" class="my-menu">
    <ion-content>
        <ion-list>
            <ion-menu-toggle>
                <img src="assets/img/close.png" alt="close" class="close">
            </ion-menu-toggle>

            <div class="logo-box">
                <img [src]="userService.companyLogo" alt="logo" class="logo">
            </div>

            <ion-menu-toggle *ngIf="userService.userInfo">
                <div class="item"
                     (click)="navigateHome()">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/house-black.svg' : 'assets/img/menu/house.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_HOME__' | translate}}</div>
                </div>

                <div class="item"
                     (click)="navigate(['/tasks'])" *ngIf="isTaskEnabled && userType !== 'coach'">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/list-black.svg' : 'assets/img/menu/list.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_TASKS__' | translate}}</div>
                    <div class="number" [@enter] [@leave]
                         *ngIf="progress !== null && progress.tasks.incompleted > 0">
                        {{progress.tasks.incompleted}}
                    </div>
                </div>

                <div class="item"
                     (click)="navigate(['/skills-checker'])" *ngIf="userType !== 'coach' && userService.userInfo.is_skillschecker">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/list-black.svg' : 'assets/img/menu/list.svg'" alt="#"></div>
                    <div class="text">{{'__FOOTER_SC__' | translate}}</div>
                </div>

                <div class="item"
                     (click)="navigate(['/coach/journey'])" *ngIf="userType !== 'coach' && userService.userInfo.is_coaching">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/coach-calendar-main-black.svg' : 'assets/img/coach-calendar-main-white.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_COACHING_JOURNEY__' | translate}}</div>
                </div>

                <div class="item"
                     (click)="navigate(['/review'])" *ngIf="userType !== 'coach' && userService.userInfo.company.enabled_review">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/list-black.svg' : 'assets/img/menu/list.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_REVIEW__' | translate}}</div>
                </div>

                <ng-container *ngIf="isManager">

                    <div class="item" [@leave] [@enter]
                         *ngIf="userService.userInfo.company.enabled_sk"
                         (click)="navigate(['/skills-checker/team'])">
                        <div class="image"><app-inline-svg [file]="userService.headerMode === 'light' ? 'assets/img/menu/users-black.svg' : 'assets/img/menu/users.svg'"></app-inline-svg></div>
                        <div class="text">{{'__MENU_TEAM_SC__' | translate}}</div>
                        <div class="number" [@enter] [@leave]
                             *ngIf="progress !== null && progress.skillschecker.incompleted > 0">
                            {{progress.skillschecker.incompleted}}
                        </div>
                    </div>

                    <div class="item" [@leave] [@enter]
                         *ngIf="userService.userInfo.company.enabled_coaching"
                         (click)="navigate(['/coaching/team'])">
                        <div class="image"><app-inline-svg [file]="userService.headerMode === 'light' ? 'assets/img/menu/group-black.svg' : 'assets/img/menu/group.svg'"></app-inline-svg></div>
                        <div class="text">{{'__MENU_TEAM_COACHING__' | translate}}</div>
                        <div class="number" [@enter] [@leave]
                             *ngIf="progress !== null && progress.coaching.incompleted > 0">
                            {{progress.coaching.incompleted}}
                        </div>
                    </div>

                    <div class="item" [@leave] [@enter]
                         *ngIf="userService.userInfo.company.enabled_review"
                         (click)="navigate(['/team'])">
                        <div class="image"><app-inline-svg [file]="userService.headerMode === 'light' ? 'assets/img/menu/group-black.svg' : 'assets/img/menu/group.svg'"></app-inline-svg></div>
                        <div class="text">{{'__MENU_TEAM_REVIEW__' | translate}}</div>
                    </div>

                </ng-container>

                <div class="item"
                     (click)="navigate(['/account'])">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/user-black.svg' : 'assets/img/menu/user.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_ACCOUNT__' | translate}}</div>
                </div>

                <div class="item"
                     (click)="getActionLogOut()">
                    <div class="image"><img [src]="userService.headerMode === 'light' ? 'assets/img/menu/door-black.svg' : 'assets/img/menu/door.svg'" alt="#"></div>
                    <div class="text">{{'__MENU_LOGOUT__' | translate}}</div>
                </div>

            </ion-menu-toggle>
        </ion-list>
<!--        <div class="copyright">-->
<!--            &copy;{{'__MENU_COPYRIGHT__' | translate}}-->
<!--            <span>{{'__MENU_VERSION__' | translate}} {{authService.appVersionCode}}{{environment.appVersionSuffix}}</span>-->
<!--        </div>-->
    </ion-content>
</ion-menu>
